<!-- svelte-ignore a11y-distracting-elements -->
<marquee><slot /></marquee>
